import { useCallback, useState } from 'react';

import { EikaMessageEvent, parseCallback, useNativeEventListener, WebActions } from '@eika-infrastruktur/mobilbank-lib';

export type ApplePayActions = Extract<WebActions, 'APPLE_PAY_PROVISION_RESULT' | 'APPLE_PAY_PROVISION_ERROR'>;

type ProvisionEventStatus = 'initial' | 'error' | 'success' | 'pending';

export type ProvisionHandle = {
    status: ProvisionEventStatus;
    cleanup(): void;
    setIsPending(): void;
};

export const useHandleApplePayProvisioningEvent = (): ProvisionHandle => {
    const [status, setStatus] = useState<ProvisionEventStatus>('initial');

    const onMessage = useCallback(
        (event: EikaMessageEvent<ApplePayActions>) => {
            const data = parseCallback<ApplePayActions>(event.data);
            if (data) {
                switch (data.action) {
                    case 'APPLE_PAY_PROVISION_ERROR':
                        setStatus('error');
                        break;
                    case 'APPLE_PAY_PROVISION_RESULT':
                        setStatus('success');
                        break;
                    default:
                        break;
                }
            }
        },
        [setStatus],
    );

    useNativeEventListener(onMessage);

    const cleanup = useCallback(() => {
        setStatus('initial');
    }, [setStatus]);

    return { status, cleanup, setIsPending: () => setStatus('pending') };
};

export default useHandleApplePayProvisioningEvent;
